/**
 * Admin application route paths
 */
export const ADMIN_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CUSTOMER_MANAGEMENT: '/customer-management',
  CUSTOMER_DETAILS: (id: string) => `/customer-management/${id}`,
  PROPERTY_DETAILS: (id: string) => `/customer-management/properties/${id}`,
  LISTING_MANAGEMENT: '/listing-management',
  LISTING_DETAILS: (id: string) => `/listing-management/${id}`,
} as const;

